import ReactDocumentTitle from '~/components/ReactDocumentTitle';
import React from 'react';
import gql from 'graphql-tag';
import {useHistory, useParams} from 'react-router';
import {useMutation, useQuery} from '@apollo/client';
import AppLayout from '../../../layouts/AppLayout';
import FormTitle from '../../../ui/FormTitle';
import BackLink from '../../../ui/BackLink';
import OldUrls from '../../../models/utils/OldUrls';
import {handleError, handleSuccess} from '../../../utils/Apollo';
import {AllConfigurationRulesFragment, CompleteSectionConfigurationFragment} from '../formConfiguration/fragments';
import ConfigurationForm from './ConfigurationForm';
import SceneSkeleton from "../evaluationFormConfiguration/SceneSkeleton";

export default function EditScene() {
  const {id} = useParams();
  const {loading, data, error} = useQuery(query, {
    variables: {id},
    errorPolicy: 'all',
  });
  const [submit] = useMutation(updateFormMutation);
  const history = useHistory();
  const backLink = OldUrls.registrationFormConfigurations();

  const onFormSubmit = React.useCallback((formData) => {
    submit({
      variables: {data: formData, id},
    }).then(
      () => handleSuccess('Configuration updated', backLink),
      (apolloError) => handleError(apolloError),
    );
  }, [submit, history]);

  if (error) {
    handleError(error, false);
  }

  return (
    <>
      <ReactDocumentTitle title="Edit registration form configuration"/>
      <AppLayout className="bg-gray-light">
        <BackLink backLink={backLink}/>
        <FormTitle>Edit registration form configuration</FormTitle>
        {error && <SceneSkeleton/>}
        {loading && <SceneSkeleton/>}
        {!loading && !error &&
        <>
          <ConfigurationForm sectionConfigurations={data.sectionConfigurations} backLink={backLink}
            onSubmit={onFormSubmit} configuration={data.settings}/>
        </>
        }
      </AppLayout>
    </>
  );
}

const query = gql`
  query RegistrationFormSettingsQuery($id: ID!) {
    account {
      id
      __typename
    }

    sectionConfigurations: registrationFormSectionConfigurations {
      ...CompleteSectionConfiguration
    }

    settings: registrationFormConfiguration(id: $id) {
      id
      rules {
        ...AllConfigurationRules
      }
      instructions
      sections {
        id
        fields {
          id
          required
        }
      }
    }
  }
  ${AllConfigurationRulesFragment}
  ${CompleteSectionConfigurationFragment}
`;

const updateFormMutation = gql`
  mutation UpdateFormMutation($id: ID!, $data: RegistrationFormConfigurationInput!) {
    updateRegistrationFormConfiguration(id: $id, data: $data) {
      instructions
      sections {
        id
      }
    }
  }
`;
